import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IActivity } from '../../../dto-map/i-activity';
import { ActivityCollectionService } from '../activity-collection/activity-collection.service';

@Component({
  selector: 'ss-activity-collection-unordered',
  host: {
    class: 'flex-column gap-standard',
  },
  templateUrl: './activity-collection-unordered.component.html',
  styleUrls: ['./activity-collection-unordered.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityCollectionUnorderedComponent {

  readonly activitiesSubject = this._activityCollectionService.activitiesSubject;

  constructor(
    private readonly _activityCollectionService: ActivityCollectionService
  ) {

  }


  trackActivityById(idx: number, activity: IActivity) {
    return activity.id
  }
}
